<div class="betbuilder-custom-message" *ngIf="customMessage">{{ customMessage }}</div>
